var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var SvgPinGeolocate = function SvgPinGeolocate(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 7.98h-1.684a6.331 6.331 0 00-5.983-5.984V.313h-.666v1.683A6.331 6.331 0 001.684 7.98H0v.667h1.684a6.331 6.331 0 005.983 5.983v1.684h.666v-1.684a6.331 6.331 0 005.983-5.983H16v-.667zm-7.667 5.982v-1.65h-.666v1.65A5.665 5.665 0 012.35 8.646H4v-.667H2.35a5.665 5.665 0 015.317-5.316v1.65h.666v-1.65a5.665 5.665 0 015.317 5.316H12v.667h1.65a5.665 5.665 0 01-5.317 5.316z",
    fill: "#333"
  })));
};

export default SvgPinGeolocate;